$(function() {
    $('[data-input-range]').each(function() {
        init(this);
    });

    function init(el) {
        $(el).ionRangeSlider();
    }
});